import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <hr style={{ width: "100%", marginTop: 0 }} />
      <span className="name">
        A Word Translator by{" "}
        <a href="https://www.aminbeheshti.com" target="__blank">
          Amin Beheshti
        </a>
      </span>
      <div className="iconContainer">
        <a href="https://www.instagram.com/aminbeheshti_com/" target="__blank">
          <i className="fab fa-instagram-square fa-2x"></i>
        </a>
        <a href="https://www.linkedin.com/in/aminbeheshti" target="__blank">
          <i className="fab fa-linkedin fa-2x"></i>
        </a>
        <a href="https://github.com/abport" target="__blank">
          <i className="fab fa-github fa-2x"></i>
        </a>
        <a href="https://twitter.com/aminbeheshti" target="__blank">
          <i className="fab fa-twitter fa-2x"></i>
        </a>
        <a href="https://t.me/abeheshti" target="__blank">
          <i className="fab fa-telegram fa-2x"></i>
        </a>
      </div>
    </div>
  );
};

export default Footer;
